
export interface IUnreadEventsState {
    unreadEvents: number;
}

export const initialUnreadEventsState = {
    unreadEvents: undefined,
};
